/* Preserve pinch-zoom and other user scaling controls on touch devices. */
(function () {
  var viewport = document.querySelector('meta[name="viewport"]');
  if (!viewport) return;

  var content = viewport.getAttribute('content') || '';
  var restore = function () {
    viewport.setAttribute('content', content);
  };

  restore();
  document.addEventListener('touchstart', restore, { passive: true });

  document.addEventListener('click', function (event) {
    var accordion = event.target.closest('.data.accordition');
    if (accordion) {
      var expanded = accordion.getAttribute('aria-expanded') === 'true';
      accordion.setAttribute('aria-expanded', String(!expanded));
    }

    var tab = event.target.closest('[role="tab"]');
    if (tab) {
      document.querySelectorAll('[role="tab"]').forEach(function (item) {
        item.setAttribute('aria-selected', String(item === tab));
      });
    }
  });
})();
